//记录用户信息
export function getAdmins(member_id){
    let type = {
        byId: member_id,
        channel:'web',
        os:'',
        ip:'',
        version:'',
    }
    //取本地中的数据
    type.ip = localStorage.getItem('ip')
    let system = navigator.userAgent.toLowerCase();
    const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    const windows = system.indexOf("windows");
    if (windows !== -1) {
        type.os = 'windows'
    }else if (isMac) {
        type.os = 'mac'
    }else {
        type.os = 'unknown device'
    }
    let version = null;
    if (system.indexOf("mac os x") > 0) {
        const regOs = /mac os x [\d_]+/gi;
        const v_infoOs = system.match(regOs);
        version = (v_infoOs + "").replace(/[^0-9_]/ig, "").replace(/_/ig, "."); //得到版本号
        type.version = version
    }else if (system.indexOf('windows') > 0) {
        version = system.match(/windows\s*(nt\s*[\d+.]+)/)[1];  // 获取版本号
        type.version = version
    }
    return type;
}
